export const statusDocument = {
  INIT: 'init',
  SEND: 'send',
  PENDING: 'pending',
  COMPLETED: 'completed',
  PROCESSED: 'processed',
  CANCELLED: 'cancelled'
};
